import React from 'react';
import { Clock, Star } from 'lucide-react';

function ChallengeCard({
  title,
  description,
  credits,
  difficulty,
  timeRemaining,
  progress,
}) {
  const difficultyColor = {
    Easy: 'bg-green-100 text-green-800',
    Medium: 'bg-yellow-100 text-yellow-800',
    Hard: 'bg-red-100 text-red-800',
  }[difficulty];

  return (
    <div className="bg-white rounded-xl shadow-lg p-6 transform transition-all duration-300 hover:scale-105 hover:shadow-xl">
      <div className="flex justify-between items-start mb-4">
        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        <span className={`px-3 py-1 rounded-full text-sm font-medium ${difficultyColor}`}>
          {difficulty}
        </span>
      </div>
      
      <p className="text-gray-600 mb-4">{description}</p>
      
      <div className="space-y-4">
        <div className="flex items-center text-gray-700">
          <Star className="h-5 w-5 text-[#0dceda] mr-2" />
          <span>{credits} Credits</span>
        </div>
        
        <div className="flex items-center text-gray-700">
          <Clock className="h-5 w-5 text-[#0dceda] mr-2" />
          <span>{timeRemaining}</span>
        </div>
        
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-600">Progress</span>
            <span className="text-sm font-medium text-[#0dceda]">{progress}%</span>
          </div>
          <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
            <div
              className="h-full bg-[#0dceda] transition-all duration-300"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChallengeCard;